import IPostMessage from '../IPostMessage';
import ITouchEventMessage from './ITouchEventMessage';

export default class Touch {
	public static MESSAGE_PREFIX: string = 'touch';

	/** @internal */
	constructor(
		public readonly window: Window,
		private messagePrefix: string,
		private postMessageToParent: IPostMessage<void>,
	) {
		const handleTouch = (event: TouchEvent) => this.handleTouch(event);
		this.window.addEventListener('touchstart', handleTouch, true);
		this.window.addEventListener('touchend', handleTouch, true);
		this.window.addEventListener('touchcancel', handleTouch, true);
		this.window.addEventListener('touchmove', handleTouch, true);
	}

	/** @internal */
	public handleMessageData(data: ITouchEventMessage) {
		switch (data.type) {
			case this.getMessage('propagate'): {
				const elementToClick = this.window.document.elementFromPoint(data.x, data.y);
				if (elementToClick && 'click' in elementToClick) {
					(elementToClick as HTMLElement).click();
				}
				break;
			}
			default:
		}
	}

	/** @internal */
	public transformIframeData(originalData: ITouchEventMessage, targetWindow: Window) {
		if (originalData.type !== this.getMessage('propagate')) {
			return originalData;
		}
		const detectedIframes = Array.from(this.window.document.getElementsByTagName('iframe'));
		const targetIframe = detectedIframes.find((iframe: HTMLIFrameElement) => {
			return iframe.contentWindow === targetWindow;
		});
		if (
			typeof targetIframe === 'undefined' ||
			originalData.x < targetIframe.offsetLeft ||
			originalData.x > targetIframe.offsetLeft + targetIframe.offsetWidth ||
			originalData.y < targetIframe.offsetTop ||
			originalData.y > targetIframe.offsetTop + targetIframe.offsetHeight
		) {
			return undefined;
		}
		return {
			...originalData,
			x: originalData.x - targetIframe.offsetLeft,
			y: originalData.y - targetIframe.offsetTop,
		};
	}

	private handleTouch(event: TouchEvent) {
		void this.postMessageToParent({
			type: this.getMessage('event'),
			eventType: event.type,
		});
	}

	private getMessage(name: string) {
		return this.messagePrefix + '.' + Touch.MESSAGE_PREFIX + '.' + name;
	}
}
